import(/* webpackMode: "eager" */ "/u0/app/app/error.tsx");
